module.exports = __webpack_public_path__ + "img/onlinen020.0d2fda1a.png";